// This file was automatically generated from app.shared.dialog.enterpriseImportPatientFTUX.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.enterpriseImportPatientFTUX');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.enterpriseImportPatientFTUX.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form><div class="overlayContainer">');
  if (opt_data.lhsImported) {
    el8.template.app.shared.dialog.enterpriseImportPatientFTUX.lhsImported(opt_data, output);
  } else {
    el8.template.app.shared.dialog.enterpriseImportPatientFTUX.lhsNotImported(opt_data, output);
  }
  output.append('</div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.enterpriseImportPatientFTUX.lhsImported = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8StandardFontSize mb20">For your convenience, this patient\'s Clinical Profile has been pre-populated with the Clinical Profile from ', (opt_data.plrCollaborators && opt_data.plrCollaborators.length == 1) ? soy.$$escapeHtml(opt_data.plrCollaborators[0].physicianName) + '.' : 'their current provider.', '</div>');
  el8.template.app.shared.dialog.enterpriseImportPatientFTUX.autoSearch(null, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.enterpriseImportPatientFTUX.lhsNotImported = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.app.shared.dialog.enterpriseImportPatientFTUX.autoSearch(null, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.enterpriseImportPatientFTUX.autoSearch = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8777">Once you dismiss this window, you will be viewing all shared documents through your enterprise. Click on the title of a document to view it. To import a document into your chart, click “Sign &amp; Import into My Chart.”</p><p class="el8777">To return to the view of your chart for this patient, click the [x] in the Search Bar to clear the search.</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.enterpriseImportPatientFTUX.compareRefpanelBubble = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FTUEBoxContainer"><p class="el8StandardFontSize" style="color: #fff">This patient\'s current providers are displayed along the left side. View each provider\'s Clinical Profile by clicking their name, and either import the entire profile with "Import Profile" at the top of the screen, or import by item or by section with the various "Import" buttons.</div><div class="el8FTUEBoxPointerRight"></div>');
  if (!opt_sb) return output.toString();
};
